import React from 'react';

function ViewGotra({ data }) {
  if (!data) {
    return <div className="text-center py-4">No data available</div>;
  }

  // Fields to display (excluding internal fields)
  const displayFields = [
    { key: 'gotra_name', label: 'Gotra Name' },
    { key: 'name', label: 'Gotra Name' },
    { key: 'status', label: 'Status' },
    { key: 'created_at', label: 'Created At' },
    { key: 'updated_at', label: 'Updated At' },
  ];

  const getValue = (key) => {
    if (key === 'status') {
      const status = data[key] || data.status;
      return (
        <span className={`badge ${status === 'active' ? 'bg-success' : 'bg-danger'}`}>
          {status ? status.toUpperCase() : 'N/A'}
        </span>
      );
    }
    return data[key] || 'N/A';
  };

  const getDisplayKey = (key) => {
    const field = displayFields.find(f => f.key === key);
    return field ? field.label : key.replace(/_/g, ' ').toUpperCase();
  };

  // Get available keys from data
  const availableKeys = Object.keys(data).filter(key => 
    !['id'].includes(key)
  );

  return (
    <div className="view-gotra-container">
      <div className="table-responsive">
        <table className="table table-bordered table-striped">
          <tbody>
            {availableKeys.map((key) => (
              <tr key={key}>
                <th style={{ width: '40%', backgroundColor: '#f8f9fa' }}>
                  {getDisplayKey(key)}
                </th>
                <td>
                  {key === 'status' ? getValue(key) : data[key] || 'N/A'}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default ViewGotra;